/* Site-Specific JavaScript */
jq(document).ready(() => {
    let header = document.getElementById('site-header');
    if (!header) {
        return;
    }

    function updateScrolledClass() {
        if (window.pageYOffset > 0) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    }

    window.addEventListener('scroll', updateScrolledClass, { passive: true });
    updateScrolledClass();
});
